<!-- <div class="main_box">
  <div class="row row_c admin_dash_outer" style="padding-top: 16px;">
    <div class="col-md-4" style="cursor: pointer;">
      <mat-card (click)="goToClientList()" class="admin_dash_info">
        <div class="list-box-one" fxLayout fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">
          <div class="custom-padding box1" fxFlex="30%">
            <img class="list-image-custom" src="assets/client.PNG">
          </div>
          <div class="custom-padding box2" fxFlex="70%">
            <h6 class="tile_txt">Clients summary</h6>
            <span>{{clientsValue}}</span>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="col-md-4" style="cursor: pointer;">
      <mat-card (click)="goToDeviceList()" class="admin_dash_info">
        <div class="list-box-one" fxLayout fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">
          <div class="custom-padding box1" fxFlex="30%">
            <img class="list-image-custom" src="assets/summary.PNG">
          </div>
          <div class="custom-padding box2" fxFlex="70%">
            <h6 class="tile_txt">Device summary</h6>
            <span>{{devicesValue}}</span>
          </div>
        </div>
      </mat-card>
    </div>

    <div class="col-md-4" style="cursor: pointer;">
      <mat-card (click)="showNewDevices()" class="admin_dash_info">
        <div class="list-box-one" fxLayout fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">
          <div class="custom-padding box1" fxFlex="30%">
            <img class="list-image-custom" src="assets/add.PNG">
          </div>
          <div class="custom-padding box2" fxFlex="70%">
            <h6 class="tile_txt">New devices registered</h6>
            <span>{{regDevicesValue}}</span>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div> -->


<!-- <div class="dashboard-container">
  <mat-card class="dashboard-card blue-card" (click)="goToClientList()">
    <div class="dashboard-icon">
      <mat-icon class="icon">group</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>CLIENTS SUMMARY</mat-card-title>
      <mat-card-content><p>{{clientsValue}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card blue-card" (click)="goToDeviceList()">
    <div class="dashboard-icon">
      <mat-icon class="icon">devices</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>DEVICE SUMMARY</mat-card-title>
      <mat-card-content><p>{{devicesValue}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card blue-card" (click)="showNewDevices()">
    <div class="dashboard-icon">
      <mat-icon class="icon">check_circle</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>NEW DEVICES REGISTERED</mat-card-title>
      <mat-card-content><p>{{regDevicesValue}}</p></mat-card-content>
    </div>
  </mat-card>
</div>
<h2 class="dashboard-heading">Kurtosis Processing Summary</h2>
<div class="dashboard-container kurtosis">
  <mat-card class="dashboard-card green-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">check</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Processed Today</mat-card-title>
      <mat-card-content><p>{{kurtosisProcessedTodayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card red-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">hourglass_empty</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Unprocessed Today</mat-card-title>
      <mat-card-content><p>{{kurtosisUnprocessedTodayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card green-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">check_circle_outline</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Processed Yesterday</mat-card-title>
      <mat-card-content><p>{{kurtosisProcessedYesterdayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card red-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">highlight_off</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Unprocessed Yesterday</mat-card-title>
      <mat-card-content><p>{{kurtosisUnprocessedYesterdayCount}}</p></mat-card-content>
    </div>
  </mat-card>
</div>
<h2 class="dashboard-heading">Files Processing Summary</h2>
<div class="dashboard-container iot-bot">
  <mat-card class="dashboard-card green-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">file_download_done</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Processed Today</mat-card-title>
      <mat-card-content><p>{{summaryProcessedTodayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card red-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">pending</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Unprocessed Today</mat-card-title>
      <mat-card-content><p>{{summaryUnprocessedTodayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card green-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">file_download_done</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Processed Yesterday</mat-card-title>
      <mat-card-content><p>{{summaryProcessedYesterdayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card red-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">pending</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Unprocessed Yesterday</mat-card-title>
      <mat-card-content><p>{{summaryUnprocessedYesterdayCount}}</p></mat-card-content>
    </div>
  </mat-card>
</div>
<h2 class="dashboard-heading">Full Refresh Files Summary</h2>
<div class="dashboard-container iot-bot">
  <mat-card class="dashboard-card green-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">sync</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Processed Today</mat-card-title>
      <mat-card-content><p>{{fullProcessedTodayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card red-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">sync</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Unprocessed Today</mat-card-title>
      <mat-card-content><p>{{fullUnprocessedTodayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card green-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">sync</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Processed Yesterday</mat-card-title>
      <mat-card-content><p>{{fullProcessedYesterdayCount}}</p></mat-card-content>
    </div>
  </mat-card>

  <mat-card class="dashboard-card red-card">
    <div class="dashboard-icon">
      <mat-icon class="icon">sync</mat-icon>
    </div>
    <div class="dashboard-content">
      <mat-card-title>Unprocessed Yesterday</mat-card-title>
      <mat-card-content><p>{{fullUnprocessedYesterdayCount}}</p></mat-card-content>
    </div>
  </mat-card>
</div>
<h2 class="dashboard-heading">Top N Devices Sending Most Files</h2>

<table class="table-auto border-collapse border border-gray-300 w-full mt-4">
  <thead>
    <tr class="bg-gray-200">
      <th class="border border-gray-400 px-4 py-2">MAC Address</th>
      <th class="border border-gray-400 px-4 py-2">Serial Number</th>
      <th class="border border-gray-400 px-4 py-2">Company Name</th>
      <th class="border border-gray-400 px-4 py-2">Summary Files Count</th>
      <th class="border border-gray-400 px-4 py-2">Full Refresh Files Count</th>
      <th class="border border-gray-400 px-4 py-2">Summary Files Threshold</th>
      <th class="border border-gray-400 px-4 py-2">Full Refresh Files Threshold</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let device of devicesSendingMostFiles">
      <td class="border border-gray-400 px-4 py-2">{{ device.macAddress }}</td>
      <td class="border border-gray-400 px-4 py-2">{{ device.serialNumber }}</td>
      <td class="border border-gray-400 px-4 py-2">{{ device.companyName }}</td>
      <td class="border border-gray-400 px-4 py-2">{{ device.summaryFilesCount }}</td>
      <td class="border border-gray-400 px-4 py-2">{{ device.fullRefreshFilesCount }}</td>
      <td class="border border-gray-400 px-4 py-2">{{ device.summaryFilesThreshold }}</td>
      <td class="border border-gray-400 px-4 py-2">{{ device.fullRefreshFilesThreshold }}</td>
    </tr>
  </tbody>
</table> -->
<div class="dashboard">
  <!-- Top Stats Cards -->
  <div class="stats-row animate-fade-in">
    <div class="stat-card primary-gradient" (click)="goToClientList()">
      <div class="stat-icon">
        <i class="material-icons">group</i>
      </div>
      <div class="stat-content">
        <h3>CLIENTS SUMMARY</h3>
        <p class="stat-value counter">{{tempClientsValue}}</p>
      </div>
    </div>

    <div class="stat-card success-gradient" (click)="goToDeviceList()">
      <div class="stat-icon">
        <i class="material-icons">devices</i>
      </div>
      <div class="stat-content">
        <h3>DEVICE UNUSED & FREE</h3>
        <p class="stat-value counter">{{tempDeviceUnusedFree}}</p>
      </div>
    </div>

    <div class="stat-card primary-gradient" (click)="goToDeviceList()">
      <div class="stat-icon">
        <i class="material-icons">devices</i>
      </div>
      <div class="stat-content">
        <h3>DEVICE ASSOCIATED & FREE</h3>
        <p class="stat-value counter">{{tempDeviceAssociatedFree}}</p>
      </div>
    </div>

    <div class="stat-card success-gradient" (click)="goToDeviceList()">
      <div class="stat-icon">
        <i class="material-icons">devices</i>
      </div>
      <div class="stat-content">
        <h3>DEVICE ASSOCIATED & USED</h3>
        <p class="stat-value counter">{{tempDeviceAssociatedUsed}}</p>
      </div>
    </div>

    <!-- <div class="stat-card primary-gradient" (click)="showNewDevices()">
      <div class="stat-icon">
        <i class="material-icons">check_circle</i>
      </div>
      <div class="stat-content">
        <h3>NEW DEVICES REGISTERED</h3>
        <p class="stat-value counter">{{tempRegValue}}</p>
      </div>
    </div> -->
    <div class="stat-card danger-gradient">
      <div class="stat-icon">
        <i class="material-icons">warning</i>
      </div>
      <div class="stat-content">
        <h3>NUMBER OF ALERTS GENERATED</h3>
        <p class="stat-value counter">{{tempnumberOfAlertsGeneratedCount}}</p>
      </div>
    </div>
    <div class="" style="display: flex; flex-direction: column;">
      <span class="date-text">{{ today }}</span>
      <button mat-raised-button color="primary" (click)="refreshDashboardData()" [disabled]="isRefreshing">
        <mat-icon *ngIf="!isRefreshing">refresh</mat-icon>
        <mat-spinner *ngIf="isRefreshing" diameter="20"></mat-spinner>
        <span style="margin-left: 4px;">{{ isRefreshing ? 'Refreshing...' : 'Refresh' }}</span>
      </button>
    </div>

  </div>

  <!-- Processing Summary Section -->
  <div class="dashboard-section animate-slide-up">
    <div class="section-left">
      <h2 class="section-title">Kurtosis Processing Summary</h2>
      <div class="stat-cards-container">
        <div class="stat-row">
          <div class="stat-card success-gradient">
            <div class="stat-icon">
              <i class="material-icons">check</i>
            </div>
            <div class="stat-content">
              <h3>Processed Today</h3>
              <p class="stat-value counter">{{tempkurtosisProcessedTodayCount}}</p>
            </div>
          </div>

          <div class="stat-card danger-gradient">
            <div class="stat-icon">
              <i class="material-icons">hourglass_empty</i>
            </div>
            <div class="stat-content">
              <h3>Unprocessed Today</h3>
              <p class="stat-value counter">{{tempkurtosisUnprocessedTodayCount}}</p>
            </div>
          </div>
        </div>

        <div class="stat-row">
          <div class="stat-card success-gradient">
            <div class="stat-icon">
              <i class="material-icons">check_circle_outline</i>
            </div>
            <div class="stat-content">
              <h3>Processed Yesterday</h3>
              <p class="stat-value counter">{{tempkurtosisProcessedYesterdayCount}}</p>
            </div>
          </div>

          <div class="stat-card danger-gradient">
            <div class="stat-icon">
              <i class="material-icons">highlight_off</i>
            </div>
            <div class="stat-content">
              <h3>Unprocessed Yesterday</h3>
              <p class="stat-value counter">{{tempkurtosisUnprocessedYesterdayCount}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-right">
      <h2 class="section-title">Summary Files Stats</h2>
      <div class="stat-cards-container">
        <div class="stat-row">
          <div class="stat-card success-gradient">
            <div class="stat-icon">
              <i class="material-icons">file_download_done</i>
            </div>
            <div class="stat-content">
              <h3>Processed Today</h3>
              <p class="stat-value counter">{{tempsummaryProcessedTodayCount}}</p>
            </div>
          </div>

          <div class="stat-card danger-gradient">
            <div class="stat-icon">
              <i class="material-icons">pending</i>
            </div>
            <div class="stat-content">
              <h3>Unprocessed Today</h3>
              <p class="stat-value counter">{{tempsummaryUnprocessedTodayCount}}</p>
            </div>
          </div>

          <div class="stat-card info-gradient">
            <div class="stat-icon">
              <i class="material-icons">library_books</i>
            </div>
            <div class="stat-content">
              <h3>Total Files</h3>
              <p class="stat-value counter">{{tempsummaryProcessedTodayCount + tempsummaryUnprocessedTodayCount}}</p>
            </div>
          </div>
        </div>

        <div class="stat-row">
          <div class="stat-card success-gradient">
            <div class="stat-icon">
              <i class="material-icons">file_download_done</i>
            </div>
            <div class="stat-content">
              <h3>Processed Yesterday</h3>
              <p class="stat-value counter">{{tempsummaryProcessedYesterdayCount}}</p>
            </div>
          </div>

          <div class="stat-card danger-gradient">
            <div class="stat-icon">
              <i class="material-icons">pending</i>
            </div>
            <div class="stat-content">
              <h3>Unprocessed Yesterday</h3>
              <p class="stat-value counter">{{tempsummaryUnprocessedYesterdayCount}}</p>
            </div>
          </div>

          <div class="stat-card info-gradient">
            <div class="stat-icon">
              <i class="material-icons">library_books</i>
            </div>
            <div class="stat-content">
              <h3>Total Files</h3>
              <p class="stat-value counter">{{tempsummaryProcessedYesterdayCount + tempsummaryUnprocessedYesterdayCount}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Full Refresh Files Section -->
  <div class="dashboard-section animate-slide-up" style="animation-delay: 0.2s;">
    <div class="section-left">
      <h2 class="section-title">Full Refresh Files Stats</h2>
      <div class="stat-cards-container">
        <div class="stat-row">
          <div class="stat-card success-gradient">
            <div class="stat-icon">
              <i class="material-icons">file_download_done</i>
            </div>
            <div class="stat-content">
              <h3>Processed Today</h3>
              <p class="stat-value counter">{{tempfullProcessedTodayCount}}</p>
            </div>
          </div>

          <div class="stat-card danger-gradient">
            <div class="stat-icon">
              <i class="material-icons">pending</i>
            </div>
            <div class="stat-content">
              <h3>Unprocessed Today</h3>
              <p class="stat-value counter">{{tempfullUnprocessedTodayCount}}</p>
            </div>
          </div>

          <div class="stat-card info-gradient">
            <div class="stat-icon">
              <i class="material-icons">library_books</i>
            </div>
            <div class="stat-content">
              <h3>Total Files</h3>
              <p class="stat-value counter">{{tempfullProcessedTodayCount + tempfullUnprocessedTodayCount}}</p>
            </div>
          </div>
        </div>

        <div class="stat-row">
          <div class="stat-card success-gradient">
            <div class="stat-icon">
              <i class="material-icons">file_download_done</i>
            </div>
            <div class="stat-content">
              <h3>Processed Yesterday</h3>
              <p class="stat-value counter">{{tempfullProcessedYesterdayCount}}</p>
            </div>
          </div>

          <div class="stat-card danger-gradient">
            <div class="stat-icon">
              <i class="material-icons">pending</i>
            </div>
            <div class="stat-content">
              <h3>Unprocessed Yesterday</h3>
              <p class="stat-value counter">{{tempfullUnprocessedYesterdayCount}}</p>
            </div>
          </div>

          <div class="stat-card info-gradient">
            <div class="stat-icon">
              <i class="material-icons">library_books</i>
            </div>
            <div class="stat-content">
              <h3>Total Files</h3>
              <p class="stat-value counter">{{tempfullProcessedYesterdayCount + tempfullUnprocessedYesterdayCount}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-right">
      <h2 class="section-title">Top {{deviceSendingMostFilesLength}} Devices Sending Most Files</h2>
      <div class="sort-controls">
        <button mat-raised-button [color]="sortDirection === 'desc' ? 'primary' : 'warn'" (click)="toggleSortDirection()">
          <mat-icon>
            {{ sortDirection === 'desc' ? 'arrow_downward' : 'arrow_upward' }}
          </mat-icon>
          {{ sortDirection === 'desc' ? 'Descending' : 'Ascending' }}
        </button>

      </div>
      <div class="parent-table-container">
        <div class="data-table-container animate-fade-in" style="animation-delay: 0.4s; overflow-x: auto;">
          <table class="modern-table">
            <thead>
              <tr>
                <th>MAC Address</th>
                <th>Serial Number</th>
                <th>Company Name</th>
                <th>Summary Files Count ({{ devicesSendingMostFiles?.length ? devicesSendingMostFiles[0]?.summaryFilesThreshold : 0 }})</th>
                <th>Full Refresh Files Count ({{ devicesSendingMostFiles?.length ? devicesSendingMostFiles[0]?.fullRefreshFilesThreshold : 0 }})</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let device of sortedDevices; let i = index">
                <td style="font-weight: bold;">{{ device?.macAddress }}</td>
                <td>{{ device?.serialNumber }}</td>
                <td>{{ device?.companyName }}</td>
                <td>{{ device?.summaryFilesCount }}</td>
                <td>{{ device?.fullRefreshFilesCount }}</td>
              </tr>
              <tr *ngIf="sortedDevices.length === 0">
                <td colspan="6" class="no-data">No devices found</td>
              </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
